import apiClient from '@/api/client';
import type { SnapRequest, SnapResponse } from '@/types/snap';
import { isAxios404 } from '@/utils/axiosError';

export async function snapPoint(body: SnapRequest): Promise<SnapResponse | null> {
  try {
    const response = await apiClient.post<SnapResponse>('/api/v1/snap', body);
    return response.data;
  } catch (error) {
    if (isAxios404(error)) {
      return null;
    }
    throw error;
  }
}
